class SubscriptionSideMenu {
	constructor(side_menu, subscription) {
		this.side_menu = side_menu;
		this.subscription = subscription
		const tagsTemplate = document.getElementById('template-tags-list');
		this.tagsList = tagsTemplate.cloneNode(true);

	}

	update_side_menu() {
        console.log("in update side menu")
		if (this.subscription.status == "PAUSED") {
			this.side_menu.querySelector("#pause-button").style = "display:none";
			this.side_menu.querySelector("#active-button").style = "display:block";
            pauseSubsHideElements()
		}
		this.update_subscription_status(this.subscription.status);
		const arriveDateActual = new Date(this.subscription.nextBillingDate);
		arriveDateActual.setDate(arriveDateActual.getDate() + 4);
		const changableUntilDate = new Date(this.subscription.nextBillingDate);
		changableUntilDate.setDate(changableUntilDate.getDate());

		const changableUntilWeekday = new Intl.DateTimeFormat("en", {
			weekday: "long",
		}).format(changableUntilDate); //get weekday
		const changableUntilTime = new Intl.DateTimeFormat("en", {
			hour: "numeric",
			minute: "numeric",
		}).format(changableUntilDate); //get hour and mintue


		const arriveDateActualDay = new Intl.DateTimeFormat("en", {
			weekday: "long",
			month: "long",
			day: "numeric",
		}).format(arriveDateActual);
		this.side_menu.querySelector(".arriving-date").innerHTML = arriveDateActualDay;
		this.side_menu.querySelector(".changeable-date").innerHTML = `Changable until ${changableUntilWeekday} at ${changableUntilTime}`;
		this.side_menu.querySelector(".frequency").innerHTML = `${this.subscription.billingPolicy.intervalCount} ${this.subscription.billingPolicy.interval}`;
		var sub_total = this.get_total_price()
		var total_discount = this.get_total_discount();
		var delivery = this.get_delivery()
		var grand_total = (sub_total - total_discount + delivery.price).toFixed(2);
		this.side_menu.querySelector(".total_price").innerHTML = `$${sub_total}`;
		this.side_menu.querySelector(".discount_price").innerHTML = `-$${total_discount}`;
		this.side_menu.querySelector(".shipping_total").innerHTML = delivery.text;
		this.side_menu.querySelector(".grand_total").innerHTML = `$${grand_total > 0 ? grand_total : 0}`;

		this.update_progress_bar(this.get_total_price())
		var items = this.side_menu.querySelector("#order_subscription_items").cloneNode(true)
		this.side_menu.querySelector("#order_subscription_items").innerHTML = ""
		SubscriptionItemManager._mapLineItems(this.subscription).forEach(lineItem => {
			items.querySelector(".image-item").setAttribute("src", lineItem.image);
			items.querySelector(".title-item").innerHTML = lineItem.title;
			items.querySelector(".quantity-item").innerHTML = lineItem.quantity;
			items.querySelector(".price-item").innerHTML = (lineItem.quantity * lineItem.price).toFixed(2);

			var node = items.querySelector("div").cloneNode(true)
			node.addEventListener("click", () => {
				productPopup.openPopup(document.getElementById(`anchor-${lineItem.productId}`).dataset.handle, true)
			})
			this.side_menu.querySelector("#order_subscription_items").appendChild(node);
			this.side_menu.querySelector("#order_subscription_items").style = ""
		})
	}
	update_subscription_status(status) {
		update_subscription_status(this.side_menu, status)
	}
	update_progress_bar(total_price) {
		var free_delivery = 61;
		var minimum_order = 38;
		const progress = this.side_menu.querySelector("#progress_bar_free_shipping");
		const progress_title = this.side_menu.querySelector("#progress_title");
		let diff = free_delivery - total_price;
		let order_difference = minimum_order - total_price;
		if (order_difference <= 0) {
			if (diff >= 0) {
				diff = (diff).toFixed(2)
				progress_title.innerHTML = `You are $${diff} Away from Free Delivery ($6.95 fee).`
			} else {
				progress_title.innerHTML = `Hooray! You unlocked free delivery 🎉`

			}
		}
		else {
			minimum_order = (minimum_order).toFixed(2)
			progress_title.innerHTML = `Your order is below the $${minimum_order} minimum order.`
		}
		let percentage = ((total_price) / free_delivery) * 100;
		if (percentage >= 0) {
			progress.style = `width:${percentage}%`
		}

	}


	get_total_price() {

		return parseFloat(SubscriptionItemManager._getTotalPrice(SubscriptionItemManager._mapLineItems(this.subscription))).toFixed(2);
	}
	get_total_discount() {
		var total = parseFloat(parseFloat(this.get_total_price()) + parseFloat(this.get_delivery().price)).toFixed(2);
		var discounts = (this.subscription.discounts || {}).edges || [];
		var discounted_balance = 0.0;
		var d = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit")) {
					d = parseFloat(discounts[i].node.value.amount.amount)
					if (d > total) {
						d = total;
					}
					discounted_balance += d;

				}
                else if (discounts[i].node.title == "CHICKEN"){
                  var subLineItems = this.subscription.lines.edges;
                  for(var a = 0; a < subLineItems.length; a++){
                    //lines.edges[1].node.discountAllocations
                    //lines.edges[1].node.discountAllocations[0].amount.amount
                    if(subLineItems[a].node.discountAllocations.length == 1){
                      discounted_balance += subLineItems[a].node.discountAllocations[0].amount.amount
                    }
                  }
                }
                else if (discounts[i].node.targetType == "SHIPPING_LINE"){
                  var deliveryPrice = this.get_delivery().price
                  if(this.get_delivery().price == 0){
                    discounted_balance += 0.00;
                  }
                  else{
                    discounted_balance += 6.95;
                  } 
                }
				else if (discounts[i].node.value.percentage) {
					discounted_balance += (discounts[i].node.value.percentage * this.get_total_price()) / 100;
				}
				else if (discounts[i].node.value.amount.amount) {
					discounted_balance += parseInt(discounts[i].node.value.amount.amount);
				}
			} catch (error) {

			}
		}

		return parseFloat(discounted_balance).toFixed(2);
	}
	get_delivery() {
        var total = parseFloat(SubscriptionItemManager._getTotalPrice(SubscriptionItemManager._mapLineItems(this.subscription))).toFixed(2);
		var delivery = parseFloat((this.subscription.deliveryPrice || {}).amount || 0);
		var discounts = (this.subscription.discounts || {}).edges || [];
		var found = false;
		var price = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit"))
					found = true;
			} catch (error) {

			}
		}
		if ((delivery <= 0 || found) && total >= 61.00) {
			delivery = "Free Shipping";
			price = 0;
		} else {
			price = delivery;

			delivery = `$${delivery}`;

		}
		return { 'text': delivery, "price": price }

	}
}

class SubscriptionItemManagerPortal extends SubscriptionItemManager {
	constructor(opts, collection) {
		super(opts, collection)
		this.upcomingOrders = document.getElementById("upcoming_orders")
		this.side_menu_subscription = collection.querySelector("#subscription_side_menu");
		this.upcomingOrders_side_nav = collection.querySelector("#upcoming_orders_side_nav");
		this.payment_side_nav = collection.querySelector("#payment_side_nav")
		this.update_payment_method_form = collection.querySelector("#update_payment_method_form")

		this.apply_discount_button = collection.querySelector("#discount-button")
		this.editShippingAddressPortal = collection.querySelector("#editShippingForm");
		this.top_order_modal = document.getElementById("topOrdersModal");
		this.table = document.getElementById("top_order_table").cloneNode(true);
		const tagsTemplate = document.getElementById('template-tags-list');
		this.tagsList = tagsTemplate.cloneNode(true);
		this.button = collection.querySelector("apply-discount-new button")
		this.loadingMessage = collection.querySelector(".credit_available_message")
		this.successMessage = collection.querySelector("#success_message");
		this.errorMessage = collection.querySelector("#error_message");

		this.side_menu_subscription.querySelector("#pause-button").addEventListener("click", async () => {
			this.side_menu_subscription.querySelector("#pause-button").innerHTML = "<i class='fa fa-spinner fa-spin'></i>";

			await this.update_status("PAUSED");
			update_subscription_status(this.side_menu_subscription, "PAUSED")

			this.side_menu_subscription.querySelector("#pause-button").innerHTML = "Pause Subscription"
			this.side_menu_subscription.querySelector("#pause-button").style = "display:none";
			this.side_menu_subscription.querySelector("#active-button").style = "display:block";

			this.alert("Subscription Paused Successfully");
            pauseSubsHideElements();
		})
		this.payment_side_nav.addEventListener("click", () => {
			this.payment_method_change()
		});
		this.update_payment_method_form.addEventListener("click", () => {
			this.payment_method_change()
		});
		this.side_menu_subscription.querySelector(".change_frequency_card").addEventListener("click", () => {
			this.side_menu_subscription.querySelector("#editFrequency select").value = this.subscription.deliveryPolicy.intervalCount;
			this.side_menu_subscription.querySelector("#editFrequency").style = "display:flex"
		})
		this.side_menu_subscription.querySelector("#active-button").addEventListener("click", async () => {
			this.side_menu_subscription.querySelector("#active-button").innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
			await this.update_status("ACTIVE");
			update_subscription_status(this.side_menu_subscription, "ACTIVE")
			this.side_menu_subscription.querySelector("#active-button").innerHTML = "Resume Subscription";
			this.side_menu_subscription.querySelector("#pause-button").style = "display:block";
			this.side_menu_subscription.querySelector("#active-button").style = "display:none";
			this.side_menu_subscription.querySelector("#cancel-button").style = "display:block";

            unpauseSubsShowElements()
          
			this.alert("Subscription Activated Successfully");
		});
		this.side_menu_subscription.querySelector("#editFrequency .save").addEventListener("click", async () => {
			this.side_menu_subscription.querySelector("#editFrequency .save").disabled = true;
			this.side_menu_subscription.querySelector("#editFrequency .save").innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
			this.subscription = await this.update_frequency()
			this.side_menu_subscription.querySelector("#editFrequency .save").innerHTML = "Save";
			this.side_menu_subscription.querySelector("#editFrequency .save").disabled = false;
			this.side_menu_subscription.querySelector("#editFrequency").style = "display:none;"

		})
        this.side_menu_subscription.querySelector("#review-order").addEventListener("click", async () => {
			//this.side_menu_subscription.querySelector("#orderReview").style = "display:flex;"
            //this.side_menu_subscription.querySelector(".edit_shipping_address-content").style = "overflow: scroll;"
            const cookieValue = document.cookie
              .split("; ")
              .find((row) => row.startsWith("orderReviewed="))
              ?.split("=")[1];
            if(cookieValue != undefined){
              var cookieReviewed = cookieValue.split("-")[1];
              var cookieOrderNum = cookieValue.split("-")[0];
            }  
            if(cookieReviewed == "True"){
              this.side_menu_subscription.querySelector("#orderReview").style = "display:flex;"
              document.querySelector('#thankYouMes').style = "display:block;"
              document.querySelector('#inner_content_review').style = "display:none;"
              document.querySelector('#form-submit-btn').style = "display:none;"
            }
            else{
              this.side_menu_subscription.querySelector("#orderReview").style = "display:flex;"
            }
		});
		this.side_menu_subscription.querySelector("#cancel-button").addEventListener("click", async () => {
			this.side_menu_subscription.querySelector("#confirmationCancel").style = "display:flex;"
		});
		this.side_menu_subscription.querySelector("#confirmationCancel .save").addEventListener("click", async () => {
			this.side_menu_subscription.querySelector("#confirmationCancel .save").innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
			await this.update_status("CANCELLED");
			update_subscription_status(this.side_menu_subscription, "CANCELLED")
			this.side_menu_subscription.querySelector("#cancel-button").style = "display:none";
			this.side_menu_subscription.querySelector("#active-button").style = "display:block";
			this.side_menu_subscription.querySelector("#confirmationCancel .save").innerHTML = "Yes";
			this.side_menu_subscription.querySelector("#confirmationCancel").style = "display:none;"

            var subReason = this.side_menu_subscription.querySelector("#subCancelText").value;
            //console.log(subReason);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            
            var raw = JSON.stringify({
              "cancelReason": subReason,
              "customerEmail": customer.email,
              "customerCity": this.subscription.deliveryMethod.address.city,
              "customerProvince" : this.subscription.deliveryMethod.address.province
            });
            
            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: raw,
              mode: "no-cors",
              redirect: 'follow'
            };
            
            fetch("https://script.google.com/macros/s/AKfycbzr9x9HPdJ18ZefSPMayFNebCpCpAb8tE88CYrxTYx5EVostL8szLsQm4TSZMblTMOQ/exec", requestOptions)
              .then(response => response.text())
              .then(result => console.log(result))
              .catch(error => console.log('error', error));

            pauseSubsHideElements();
			this.alert("Subscription Cancelled Successfully");

		})

		this.editShippingAddressPortal.addEventListener("submit", async (event) => {
			event.preventDefault();
			this.editShippingAddressPortal.querySelector("#zip_error").innerHTML = "";
			this.editShippingAddressPortal.querySelector("#address-code-success").innerHTML = "";
			this.editShippingAddressPortal.querySelector("#address-code-error").innerHTML = "";
			const formData = new FormData(this.editShippingAddressPortal);
			var object = {};
			this.editShippingAddressPortal.querySelector(".submit").innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
			formData.forEach(function (value, key) {
				object[key] = value;
			});
			var geoData = {
				geoSearchQuery: object.zip,
				shop: "inspiredgo.myshopify.com"
			}
			var geoOptions = {
				method: 'POST',
				headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' },
				body: geoData
			};
			// console.log(usure,"usure")
			/*move this to new function triggered by earlier event */
			var res = await fetch('https://api-us.zapiet.com/v1.0/delivery/locations?shop=inspiredgo.myshopify.com&geoSearchQuery=' + object.zip, geoOptions)
			res = await res.json()
			if (res.error) {
				this.editShippingAddressPortal.querySelector("#zip_error").innerHTML = "Sorry, delivery is not available in your area."
				this.editShippingAddressPortal.querySelector(".submit").innerHTML = "Save";

				return;
			}
			var json = JSON.stringify(object);
			try {
				await this.edit_update_shipping_address(json);
				this.editShippingAddressPortal.querySelector("#address-code-success").innerHTML = "Shipping Address Updated Successfully";
			} catch (error) {
				this.editShippingAddressPortal.querySelector("#address-code-error").innerHTML = "Error Updating Shipping Address";
			}
			setTimeout(function () {
				document.querySelector("#address-code-error").innerHTML = "";
				document.querySelector("#address-code-success").innerHTML = "";
				document.getElementById("editShippingAddress").style = ""

			}, 1000);
			this.editShippingAddressPortal.querySelector(".submit").innerHTML = "Save";
		})

		this.apply_discount_button.addEventListener("click", async () => {

			try {
				this.apply_discount_button.innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
				this.apply_discount_button.disabled = true;
				document.getElementById("discount-code-error").innerHTML = "";

				this.subscription = await this.apply_discount(document.getElementById("discount-input").value);
				this.set_tags(this.subscription);
				this.customerDrawerOverLay.renderSubscriptionDrawer(this.subscription, this.templateDrawerItem)
				this.update_store_credit(this.subscription);
				if (((this.subscription.discounts || {}).edges || []).length > 0) {
					document.getElementById("discount-code-success").innerHTML = "Discount code applied successfully";
					this.apply_discount_button.innerHTML = "Apply";

				} else {
					document.getElementById("discount-code-error").innerHTML = "Error applying discount code"
				}
				this.apply_discount_button.disabled = false;

			} catch (error) {

				this.apply_discount_button.disabled = false;
				document.getElementById("discount-code-error").innerHTML = "Error applying discount code"
				this.apply_discount_button.innerHTML = "Apply";

			}
			new SubscriptionSideMenu(this.side_menu_subscription, this.subscription).update_side_menu()

			this.apply_discount_button.innerHTML = " Apply ";
			document.getElementById("discount-input").value = "";

		});

		this.button.addEventListener("click", async (e) => {
			this.button.innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>';
			try {
				var already_discount = ((this.subscription || {}).discounts || {}).edges || []
				var id = this.constructor._extractGid(this.subscription.id)

				if (already_discount.length > 0) {
					for (var i = 0; i < already_discount.length; i++) {

						await this.remove_discount(already_discount[i].node.id, id)
					}
				}
				var x = await this.get_discount_code();
				this.subscription = await this.apply_discount_code(id, x.discount_code);
				this.customerDrawerOverLay.renderSubscriptionDrawer(this.subscription, this.templateDrawerItem)

				this.set_tags(this.subscription)
				this.successMessage.innerHTML = "Store credit of $" + this.storeBalance + " has been applied successfully to your upcoming subscription order."
				this.update_store_credit(this.subscription);

				this.button.style = "display:none;"
				this.button.disabled = true;
				new SubscriptionSideMenu(this.side_menu_subscription, this.subscription).update_side_menu()

			}
			catch (error) {
				console.log(error)
				this.errorMessage.innerHTML = "Error applying store credit";
			}

		})

		this.upcomingOrders.addEventListener("click", async () => {
			await this.update_upcoming_order()
		});

		this.upcomingOrders_side_nav.addEventListener("click", async () => {
			await this.update_upcoming_order()
		});
		this.set_active_subscription();
		collection.querySelector("#skip_order_cancel .save").addEventListener("click", async (event) => {
			if (event.target.dataset.id) {
				event.target.innerHTML = `<i class="fa fa-spinner fa-spin" style="font-size:20px;margin: auto;"></i>`;
				event.target.disabled = true;
				await this.skip_order(event.target.dataset.id);
				var res = await this.findActiveSubscription();
				new SubscriptionSideMenu(this.side_menu_subscription, res).update_side_menu();
				document.getElementById("skip_order_cancel").style = "display:none;"
				document.getElementById(`Order_Skip_${event.target.dataset.id}`).innerHTML = "Order Skipped";
				document.getElementById(`Order_Skip_${event.target.dataset.id}`).style = "background-color: #cccccc;pointer-events:none"

				event.target.dataset.id = "";
				event.target.innerHTML = "Yes";
				event.target.disabled = false;

			}

		});
	}
	set_onclick_change() {

	}
	set_drawer_overlay_portal(drawer, templateDrawerItem) {
		this.customerDrawerOverLay = drawer;
		this.templateDrawerItem = templateDrawerItem
	}
	async payment_method_change() {
		var contract_id = this.constructor._extractGid(this.subscription.id)
		var x = contract_id.toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		var res = await this.fetch(`cp/api/subscription-contracts-update-payment-method?contractId=${contract_id}&hash=${hash}&email=${this.customerEmail}`, {
			method: 'PUT'
		})
		this.alert('Please check your email for updating payment method')

	}

	async update_frequency() {
		var frequency = this.side_menu_subscription.querySelector("#frequency").value
		var contract_id = this.constructor._extractGid(this.subscription.id)
		var x = contract_id.toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
                //cp/api/subscription-contracts-update-frequency-by-selling-planCopy
        //"monday"
        //"weekly": "873594922",
        //"biweekly": "873627690"
        //"sunday":
        //"weekly": "873529386", <--
        //"biweekly": "873562154"
        //"monday": {
        //"weekly": "412254250",
        //"biweekly": "412942378"
        //"sunday": {
        //"weekly": "411926570",
        //"biweekly": "411992106"
        //code for setting the correct selling plan based on province, day, and frequency 
        var customerProvinceCode = this.subscription.deliveryMethod.address.provinceCode
        var selectedDay = this.side_menu_subscription.querySelector(".arriving-date").innerHTML;
        selectedDay = selectedDay.split(",")[0];
        var SellingPlanId = 873594922;
        if(customerProvinceCode == "ON"){
          if(selectedDay == "Sunday" && frequency == 1){
            SellingPlanId = 873529386;
          }
          else if(selectedDay == "Sunday" && frequency == 2){
            SellingPlanId = 873562154;
          }
          else if(selectedDay == "Monday" && frequency == 1){
            SellingPlanId = 873594922;
          }
          else if(selectedDay == "Monday" && frequency == 2){
            SellingPlanId = 873627690;
          }
        }
        else{
          if(selectedDay == "Sunday" && frequency == 1){
            SellingPlanId = 411926570;
          }
          else if(selectedDay == "Sunday" && frequency == 2){
            SellingPlanId = 411992106;
          }
          else if(selectedDay == "Monday" && frequency == 1){
            SellingPlanId = 412254250;
          }
          else if(selectedDay == "Monday" && frequency == 2){
            SellingPlanId = 412942378;
          }
        }
      	var res = await this.fetch(`cp/api/subscription-contracts-update-frequency-by-selling-plan?contractId=${contract_id}&sellingPlanId=${SellingPlanId}`, {
			method: 'PUT'
		})
        //depricated old call for billing interval moved to sellingPlanId 
		//var res = await this.fetch(`cp/api/subscription-contracts-update-billing-interval?contractId=${contract_id}&interval=WEEK&intervalCount=${frequency}&hash=${hash}&email=${this.customerEmail}`, {
			//method: 'PUT'
		//})
		res = await res.json()
		var dateN = new Date(this.subscription.nextBillingDate)
		var date = new Date();
		var daytoset = dateN.getDay();
		var currentDay = date.getDay();
		var distance = daytoset - currentDay;
		date.setDate(date.getDate() + distance);
		date.setHours(17, 0, 0, 0)
		if (date.getTime() <= new Date().getTime()) {
			date.setDate(date.getDate() + (parseInt(frequency) * 7))
		}
		else {
			date.setDate(date.getDate() + ((parseInt(frequency) - 1) * 7))
		}
		var assignBillingDate = date.toLocaleDateString('sv-SE')
		const subChangeOptions = {
			method: 'PUT',
			headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' }
		}
		res = await this.fetch(`cp/api/subscription-contracts-update-billing-date?hash=${hash}&email=${this.customerEmail}&contractId=` + contract_id + "&nextBillingDate=" + assignBillingDate + "T22:00:00Z", subChangeOptions)
		res = await res.json()
		new SubscriptionSideMenu(this.side_menu_subscription, res).update_side_menu();
		return res;
	}
	set_tags(subscription) {
		var discounts = (subscription.discounts || {}).edges || [];
		document.getElementById("discount-code-success").innerHTML = ""
		document.getElementById("discount-code-error").innerHTML = ""
		document.getElementById("error_message").innerHTML = ""
		document.getElementById("success_message").innerHTML = ""

		var tag_node = this.tagsList.content.querySelector(".tags-list").cloneNode(true);
		tag_node.innerHTML = ""
		var tag = '';
		var id = this.constructor._extractGid(this.subscription.id);
		for (var i = 0; i < discounts.length; i++) {
			tag = this.tagsList.content.querySelector(".tag").cloneNode(true);
			tag.querySelector(".reduction-code__text").innerHTML = discounts[i].node.title;
			tag.querySelector(".tag__button").dataset.id = discounts[i].node.id;
			tag.querySelector(".tag__button").id = discounts[i].node.id;
			tag.id = `tag-${discounts[i].node.id}`

			tag.querySelector(".tag__button").addEventListener("click", async (e) => {
				var previous = e.currentTarget.innerHTML;
				var id_save = e.currentTarget.dataset.id;
				e.currentTarget.innerHTML = "<i class='fa fa-spinner fa-spin'></i>";
				var res = await this.remove_discount(id_save, id)
				res = await res.json()
				this.subscription = res;
				this.set_active_subscription()
				this.customerDrawerOverLay.renderSubscriptionDrawer(this.subscription, this.templateDrawerItem)

				new SubscriptionSideMenu(this.side_menu_subscription, res).update_side_menu()
				document.getElementById(`tag-${id_save}`).style = "display:none"
			})
			// tag.querySelector(".tag__button").addEventListener("click",(e)=>{
			// 	e.target.closest('.tag').style = "display:none";
			// })
			tag_node.appendChild(tag);
		}
		document.querySelector("discount-tags").innerHTML = "";
		document.querySelector("discount-tags").appendChild(tag_node);

	}

	async update_upcoming_order() {
		this.top_order_modal.style = "display:block";
		var table = document.getElementById("top_order_table");
		table.querySelector("tbody").innerHTML = ` <div id="table-loader"style="width:100%;display: flex;height: 100px;"><i class="fa fa-spinner fa-spin" style="font-size:20px;margin: auto;"></i></div>`;
		var x = await this.get_next_orders();
		var row = this.table.querySelector("#top_order_row").cloneNode(true);
		var node = null;
		var arriveDateActual = '';
		var arriveDateActualDay = '';
		var id = '';
		var deliveryDate = '';
		var count = 0;
		for (var i = 0; i < x.length; i++) {
			if (x[i].status != "SKIPPED") {
				count = count + 1;
				row.querySelector(".top-order-status").innerHTML = x[i].status;
				arriveDateActual = new Date(x[i].billingDate);
				deliveryDate = new Date(x[i].billingDate);
				var result = deliveryDate.setDate(deliveryDate.getDate() + 4);
				result = new Date(result);
				arriveDateActualDay = new Intl.DateTimeFormat("en", {
					weekday: "long",
					month: "long",
					day: "numeric",
				}).format(arriveDateActual);
				deliveryDate = new Intl.DateTimeFormat("en", {
					weekday: "long",
					month: "long",
					day: "numeric",
				}).format(result);

				row.querySelector(".top-order-date").innerHTML = arriveDateActualDay;
				row.querySelector(".top-order-delivery").innerHTML = deliveryDate;
				row.style = "";
				node = row.cloneNode(true);
				id = x[i].id;
				node.querySelector(".skip_order").dataset.id = id;
				node.querySelector(".skip_order").addEventListener("click", async (event) => {

					document.getElementById("skip_order_cancel").style = "display:flex;"
					document.querySelector("#skip_order_cancel .save").dataset.id = event.target.dataset.id;
					event.target.id = `Order_Skip_${event.target.dataset.id}`;
				})
				table.querySelector("tbody").appendChild(node);
			}
		}
		if (count <= 0) {
			table.querySelector("tbody").innerHTML = ` 
			<div id="table-loader1"style="width:100%;text-align:center">
			No record found </div>`;

		}
		else {
			table.querySelector("#table-loader").style = "display:none"
		}
	}

	update_edit_shipping_address() {
		this.editShippingAddressPortal.querySelector("#firstName").value = this.subscription?.deliveryMethod?.address?.firstName
		this.editShippingAddressPortal.querySelector("#lastName").value = this.subscription?.deliveryMethod?.address?.lastName
		this.editShippingAddressPortal.querySelector("#phone").value = this.subscription?.deliveryMethod?.address?.phone
		this.editShippingAddressPortal.querySelector("#city").value = this.subscription?.deliveryMethod?.address?.city
		this.editShippingAddressPortal.querySelector("#countryCode").value = this.subscription?.deliveryMethod?.address?.countryCode
		this.editShippingAddressPortal.querySelector("#zip").value = this.subscription?.deliveryMethod?.address?.zip
		this.editShippingAddressPortal.querySelector("#address1").value = this.subscription?.deliveryMethod?.address?.address1
		this.editShippingAddressPortal.querySelector("#address2").value = this.subscription?.deliveryMethod?.address?.address2
		this.editShippingAddressPortal.querySelector("#buzzerCode").value = this.subscription?.deliveryMethod?.address?.company
		this.editShippingAddressPortal.querySelector("#provinceCode").value = this.subscription?.deliveryMethod?.address?.provinceCode
	}
	async edit_update_shipping_address(data_send) {
		var x = (this.constructor._extractGid(this.subscription.id)).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return await this.fetch(`cp/api/subscription-contracts-update-shipping-address?hash=${hash}&email=${this.customerEmail}&contractId=${this.constructor._extractGid(this.subscription.id)}`,
			{
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: data_send

			})
	}
	async get_next_orders() {
		var x = (this.constructor._extractGid(this.subscription.id)).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return await this.fetch(`cp/api/subscription-billing-attempts/top-orders?hash=${hash}&email=${this.customerEmail}&contractId=${this.constructor._extractGid(this.subscription.id)}&customerId=${this.customerId}`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then(res => res.json());
	}

	async skip_order(id) {
		var x = (id).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return await this.fetch(`cp/api/subscription-billing-attempts/skip-order/${id}?hash=${hash}&subscriptionContractId=${this.subscriptionId}&isExternal=true&isPrepaid=false&email=${this.customerEmail}`,
			{
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then(res => res.json());

	}

	async apply_discount(discountCode) {
		var already_discount = ((this.subscription || {}).discounts || {}).edges || []
		var id = this.constructor._extractGid(this.subscription.id)

		if (already_discount.length > 0) {
			for (var i = 0; i < already_discount.length; i++) {
				await this.remove_discount(already_discount[i].node.id, id)
			}
		}

		return await this.apply_discount_code(id, discountCode)
	}

	async remove_discount(discount_id, subscribtion_id) {
		var x = (subscribtion_id).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return await this.fetch(`cp/api/subscription-contracts-remove-discount?hash=${hash}&email=${this.customerEmail}&contractId=${subscribtion_id}&discountId=${discount_id}`,
			{
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}

			})
	}

	async apply_discount_code(id, discount_code) {
		var x = (id).toString();
		x = (token + x).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return await this.fetch(`cp/api/subscription-contracts-apply-discount?contractId=${id}&discountCode=${discount_code}&hash=${hash}&email=${this.customerEmail}&shop=${this.shop}`, { method: 'PUT' })
			.then(res => res.json())
	}

	alert_succss() {
		try {
			$.toast({
				title: `Success`,
				type: 'success',
				delay: 2000
			});
		}
		catch (error) {

		}
	}
	alert(text) {
		try {
			$.toast({
				title: text,
				type: 'success',
				delay: 2000
			});
		}
		catch (error) {
			console.log(error)
		}
	}
	async _updateProduct(lineId, id, quantity) {
		return super._updateProduct(lineId, id, quantity).then(res => {
			// let side_menu = new SubscriptionSideMenu(this.side_menu_subscription, res)
			// side_menu.update_side_menu();
			// // this.alert_succss()
			// this.subscription = res;
			// this.update_store_credit(res);
			return res
		})
	}
	async _addProduct(id, quantity, price) {

		return super._addProduct(id, quantity, price).then(res => {
			// let side_menu = new SubscriptionSideMenu(this.side_menu_subscription, res)
			// side_menu.update_side_menu()
			// this.subscription = res;
			// // this.alert_succss()
			// this.update_store_credit(res);
			return res
		});
	}
	async _deleteProduct(lineId, id) {

		return super._deleteProduct(lineId, id).then(res => {
			// let side_menu = new SubscriptionSideMenu(this.side_menu_subscription, res)
			// side_menu.update_side_menu();
			// this.subscription = res;
			// this.update_store_credit(res);
			return res
		});
	}
	async set_active_subscription() {
		this.successMessage.innerHTML = "";
		this.errorMessage.innerHTML = "";
		var balance = 0
		try {
			var customer = await this.get_customer_credit()


			balance = customer.balance;

		}
		catch (error) {

		}
		// this.active_subscription = await subscription;
		var discounts = (this.subscription.discounts || {}).edges || [];
		var discounted_balance = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit")) {
					if (parseFloat(discounts[i].node.value.amount.amount) >= this.get_total_price() + this.get_delivery().price)
						discounted_balance += this.get_total_price() + this.get_delivery().price;
					else
						discounted_balance += parseFloat(discounts[i].node.value.amount.amount);

				}
			} catch (error) {
				console.log(error)
			}
		}
		balance = balance - discounted_balance;

		if (balance > 0) {
			this.storeBalance = balance;
			this.button.style = "display:block"
			// this.button.style = "margin:0"
			this.loadingMessage.innerHTML = "You have $" + this.storeBalance.toFixed(2) + " in store credit available"
			this.button.innerHTML = "Apply Store Credit to Subscription";
			this.button.disabled = false;


		} else {
			this.button.disabled = true;
			this.button.style = "display:none;"
			this.loadingMessage.innerHTML = "No store credit available"
		}

	}
	async update_status(status) {
		var id = this.constructor._extractGid(this.subscription.id)
		var z = id.toString();
		var x = (token + z).replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		var res = await this.fetch(`cp/api/subscription-contracts-update-status?hash=${hash}&contractId=${id}&status=${status}&email=${this.customerEmail}`,
			{
				method: 'PUT',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}

		)
		return true;
	}

	get_total_discount() {
		var total = this.get_total_price() + this.get_delivery().price;
		var discounts = (this.subscription.discounts || {}).edges || [];
		var discounted_balance = 0;
		var d = 0;
		for (var i = 0; i < discounts.length; i++) {
			try {
				if (discounts[i].node.title.toLowerCase().replace(/\s/g, "").includes("storecredit")) {
					d = parseInt(discounts[i].node.value.amount.amount)
					if (d > total) {
						d = total;
					}
					discounted_balance += d;
				}
				else if (discounts[i].node.value.percentage) {
					discounted_balance += (discounts[i].node.value.percentage * this.get_total_price()) / 100;
				}
				else if (discounts[i].node.value.amount.amount) {
					discounted_balance += parseInt(discounts[i].node.value.amount.amount);
				}
			} catch (error) {

			}
		}
		return discounted_balance;
	}



	get_customer_credit() {
		var x = (token + '').replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetchDiscount(`customers/get?hash=${hash}&email=${this.customerEmail}`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ "customer_email": this.customerEmail })
			}

		).then(res => res.json())
	}

	// APPSTLE REMOVED: fetchDiscount method disabled - called defunct Appstle proxy
	// fetchDiscount(url, ...args) {
	// 	return fetch("https://inspiredgo.ca/apps/appstleProxy/" + url, ...args).then(res => res)
	// }

	get_discount_code() {
		var x = (token + '').replace('\n', '')
		var hash = CryptoJS.MD5(x).toString();
		return this.fetchDiscount(`credits/checkout?hash=${hash}&email=${this.customerEmail}`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ "customer_email": this.customerEmail })
			}

		).then(res => res.json())
	}
}

class MenuWrapperSubscription extends MenuWrapper {
	init() {
		
		this.reloadSubscription = document.getElementById("reloadSubscription")
		super.init()
		this.reloadSubscription_side_nav = this.collection.querySelector("#reloadSubscription_side_nav")
		this.reloadSubscription.addEventListener("click", () => {
			this.reload_subscription()
		});
		this.reloadSubscription_side_nav.addEventListener("click", () => {
			this.reload_subscription()
		});
		if (localStorage.getItem("open_subscription") !== 'true')
			this.reload_subscription();
		if (window.location.pathname == "/pages/portal"){
			this.reloadSubscription.style="display:none !important;";
			this.reloadSubscription_side_nav.style = "display:none !important;";
		}
		localStorage.removeItem("open_subscription")
	}
	getDrawer(drawer) {
		return document.querySelector("drawer-overlay")
	}
	appendDrawer() {
	}
	reload_subscription() {
		if (window.location.pathname == "/collections/all") {
			document.getElementById("customer-portal-subscription").style = "display:none";
			document.getElementById("collection-all").style = "display:block";
			document.querySelector(".collection-hero").style = "display:block"
			document.querySelector(".drawer-overlay").style = "display:none";
			var docs = document.querySelectorAll(".drawer-overlay");
			docs.forEach(doc => {
				doc.style = "display:none";
			})
			docs = document.querySelectorAll(".popup-drawer")
			docs.forEach(doc => {
				doc.style = "display:none";
			})

			setTimeout(() => {
				document.getElementById("collection-all").classList.add("annimation-top-bottom")
				document.querySelector(".collection-hero").classList.add("annimation-top-bottom");
				document.getElementById("customer-portal-subscription").classList.remove("annimation-top-bottom")

			}, 100)

		}
	}

	subscription_settings_button_on_click() {

	}
	add_alert(id, text) {
		$.toast({
			title: `${text} Product`,
			type: 'success',
			delay: 2000
		});


	}
	get_subscription_settings_id() {
		return "#subscription_settings_button"
	}
	get_collection_template() {
		return "collectionTemplate-Subscription"
	}
	drawerOverlayTemplate() {
		return "drawerOverlayTemplate";

	}

	drawerItemTemplate() {
		return 'drawerItemTemplate-Subscription'
	}
	reload() {
		document.getElementById("appstle_overlay").style = "";
		try {
			const templateProducts = Array.from(this.productGrid.children).filter(child => child.className === 'grid__item');
			this.productGrid.innerText = '';
			var subscriptionItemManager = this.get_subscription_item_manager(this.collection)
			subscriptionItemManager.findActiveSubscription().then((subscription) => {

				this.initialize(subscription, subscriptionItemManager, templateProducts, this.templateDrawerItem).then(() => {
					document.getElementById("appstle_overlay").style = "display:none"

				}).catch(error => {
					document.getElementById("appstle_overlay").style = "display:none"

				})
			}).catch(error => {
				document.getElementById("appstle_overlay").style = "display:none"

			});
		}
		catch (error) {
			document.getElementById("appstle_overlay").style = "display:none"

		}
	}
	async initialize(subscription, subscriptionItemManager, templateProducts, templateDrawerItem) {
		subscriptionItemManager.setSubscription(subscription);
		subscriptionItemManager.set_active_subscription()
		subscriptionItemManager.update_edit_shipping_address()

		let menu;
		let drawer;
		let itemManager;
		let side_menu;
		const hasSubscription = !!subscription;
		if (hasSubscription) {
			// ---- Begin: remove duplicate items from cart, add quantities

			itemManager = subscriptionItemManager;
			await itemManager.storeSubscription(subscription)
			itemManager.subscriptionId = itemManager.constructor._extractGid(subscription.id)
			subscription = await this.combineDuplicateItems(subscription, itemManager)
			// ---- End: 
			this.side_menu_subscription = this.collection.querySelector("#subscription_side_menu")
			side_menu = new SubscriptionSideMenu(this.side_menu_subscription, subscription);
			side_menu.update_side_menu()
			subscriptionItemManager.set_tags(subscription)
			// 			
			menu = new SubscriptionCollectionMenu(this, itemManager, window.subscriptionDiscount);
			drawer = new SubscriptionDrawerOverlay(this, itemManager);
			subscriptionItemManager.set_drawer_overlay_portal(drawer, this.templateDrawerItem)

			await menu.init(templateProducts, this.productGrid, subscription);
			await drawer.init(templateDrawerItem, this.drawerItems, subscription);
		}
		else {
			itemManager = new CartItemManager();
			menu = new CartCollectionMenu(this, itemManager);
			drawer = new CartDrawerOverlay(this, itemManager);

			await menu.init(templateProducts, this.productGrid);
			await drawer.init(templateDrawerItem, this.drawerItems);
		}
		this.menu = menu;
		this.drawerOverlay = drawer;
		this.itemManager = itemManager;
		this.appstle_overlay.style.display = "none"
	}
	update_delivery_date_changed() {
		new SubscriptionSideMenu(this.side_menu_subscription, this.subscription).update_side_menu()
	}


	get_subscription_item_manager(collection) {
		if (window.screen.width <= 1240) {
			collection.querySelector("#product-grid").classList.remove("grid--4-col-desktop")
			collection.querySelector("#product-grid").classList.add("grid--3-col-desktop")

		}
		return new SubscriptionItemManagerPortal({
			shop: window.shop, customerId: window.customer.id, email: window.customer.email,
			customer_token: this.customer_token,
			customer_external_token: this.customer_external_token

		}, collection);
	}

}


customElements.define('menu-wrapper-subscription', MenuWrapperSubscription);


class DrawerOpenButtonSubscription extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("click", () => {
			const menuWrapper = document.querySelector("menu-wrapper-subscription");
			(menuWrapper.drawerOverlay || {}).openDrawer();
		});
	}
}
customElements.define("drawer-open-button-subscription", DrawerOpenButtonSubscription);



function update_subscription_status(side_menu, status) {
	side_menu.querySelector("#status-badge").innerHTML = status;
	side_menu.querySelector("#status-badge").classList.remove("badge-danger")
	side_menu.querySelector("#status-badge").classList.remove("badge-success")
	side_menu.querySelector("#status-badge").classList.remove("badge-info")

	if (status.toLowerCase() == "cancelled") {
		side_menu.querySelector("#status-badge").classList.add("badge-danger")
	}
	else if (status.toLowerCase() == "active") {
		side_menu.querySelector("#status-badge").classList.add("badge-success")
	}
	else {
		side_menu.querySelector("#status-badge").classList.add("badge-info")
	}
}

//Helper function to hide all elements that would cause confustion for customers after they pause their subscription
function pauseSubsHideElements(){
  document.querySelector("#productMenuContainer").style = "display:none";
  document.querySelector("#new_progress").style = "display:none";
  document.querySelector("#deliveryDateCard").style = "display:none";
  document.querySelector("#currentOrderCard").style = "display:none";
  document.querySelector("#deliveryCycleCard").style = "display:none";
  document.querySelector("#filterCard").style = "display:none";
  document.querySelector("#orderSummaryCard").style = "display:none";
  document.querySelector("#discountCodeCard").style = "display:none";
  document.querySelector("#storeCreditCard").style = "display:none";
  document.querySelector("#totalsCard").style = "display:none";
  document.querySelector("#mobileFilter").style = "display:none";
  document.querySelector("#mobileSettings").style = "display:none";
  //document.querySelector("#pausedSubMessage").style = "display:block";
  
}

function unpauseSubsShowElements(){
  document.querySelector("#productMenuContainer").style = "display:block";
  document.querySelector("#new_progress").style = "display:block";
  document.querySelector("#deliveryDateCard").style = "display:block";
  document.querySelector("#currentOrderCard").style = "display:block";
  document.querySelector("#deliveryCycleCard").style = "display:block";
  if (window.screen.width > 576){
    document.querySelector("#filterCard").style = "display:flex";
  }
  document.querySelector("#orderSummaryCard").style = "display:block";
  document.querySelector("#discountCodeCard").style = "display:block";
  document.querySelector("#storeCreditCard").style = "display:block";
  document.querySelector("#totalsCard").style = "display:block";
  document.querySelector("#mobileFilter").style = "display:block";
  document.querySelector("#mobileSettings").style = "display:block";
  //document.querySelector("#pausedSubMessage").style = "display:none";
}

  function closeCancelModal(){
    document.getElementById("confirmationCancel").style = "display:none;";
    unpauseSubsShowElements();
  }

  function closeReviewModal(){
    document.getElementById("orderReview").style = "display:none;";
    document.cookie = "orderReviewedSkipped=skipped; Secure";
    unpauseSubsShowElements();
  }